module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange col-12 mt-3",
    attrs: {
      "id": "addCustomer"
    },
    on: {
      "click": function($event) {
        _vm.add = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('Users.sidebar.add')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-grey view"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('paginate', {
    attrs: {
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 40
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('firstName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.firstName'))), (_vm.sort.current === 'firstName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('lastName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.lastName'))), (_vm.sort.current === 'lastName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('email', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.email'))), (_vm.sort.current === 'email') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('phoneNumber', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.phone'))), (_vm.sort.current === 'phoneNumber') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('role', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.role'))), (_vm.sort.current === 'role') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('password', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.password'))), (_vm.sort.current === 'password') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.firstName,
      "placeholder": _vm.$t('Users.firstName')
    },
    on: {
      "input": function($event) {
        _vm.fields.firstName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.lastName,
      "placeholder": _vm.$t('Users.lastName')
    },
    on: {
      "input": function($event) {
        _vm.fields.lastName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.email,
      "placeholder": _vm.$t('Users.email')
    },
    on: {
      "input": function($event) {
        _vm.fields.email = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.phoneNumber,
      "placeholder": _vm.$t('Users.phone')
    },
    on: {
      "input": function($event) {
        _vm.fields.phoneNumber = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.role,
      "placeholder": _vm.$t('Users.role')
    },
    on: {
      "input": function($event) {
        _vm.fields.role = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.password,
      "placeholder": _vm.$t('Users.password')
    },
    on: {
      "input": function($event) {
        _vm.fields.password = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(user) {
    return _c('tr', {
      key: user['.key']
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(user.firstName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(user.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.phoneNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.password))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('Users.modify')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.modifying(user)
        }
      }
    })])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.add || _vm.modify) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.add = false;
        _vm.modify = false;
        _vm.clear()
      }
    }
  }, [(_vm.add) ? _c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('Users.addTitle')))]) : _c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v(_vm._s(_vm.$t('Users.modifyTitle')))]), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.firstName,
      "type": "text",
      "placeholder": _vm.$t('Users.firstName') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.firstName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.lastName,
      "type": "text",
      "placeholder": _vm.$t('Users.lastName') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.lastName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.phoneNumber,
      "type": "text",
      "placeholder": _vm.$t('Users.phone') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.phoneNumber = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.email,
      "type": "text",
      "placeholder": _vm.$t('Users.email') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.email = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.password,
      "type": "text",
      "placeholder": _vm.$t('Users.password') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.password = $event
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.user.role,
      "disabled": _vm.modify && !_vm.isAdmin && _vm.user.role === 'Administrateur',
      "placeholder": _vm.$t('Users.role') + '*'
    },
    on: {
      "change": function($event) {
        _vm.user.role = $event
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": "Administrateur"
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.admin')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Chauffeur"
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.driver')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dispatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.dispatch')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sous-traitant"
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.subcontractor')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Autre"
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.other')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.add) ? _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.userFormCompleted
    },
    on: {
      "click": function($event) {
        _vm.addUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.addUser')))]) : _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.userFormCompleted
    },
    on: {
      "click": function($event) {
        _vm.modifyUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.modifyUser')))])]), _vm._v(" "), (_vm.modify && _vm.isAdmin) ? _c('h4', {
    staticClass: "kne-title mx-3 mt-3"
  }, [_vm._v(_vm._s(_vm.$t('Users.deleteTitle')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.modify && _vm.isAdmin) ? _c('button', {
    staticClass: "btn btn-danger w-100",
    on: {
      "click": function($event) {
        _vm.deleteUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Users.deleteUser')))]) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a516046","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Users.vue
// module id = 842
// module chunks = 1